import { Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import { TXTCLI_The_current_password_you_have__ELL } from './WrongPasswordMessage.messages.json';

interface Props {
  className?: string;
}

const WrongPasswordMessage: React.FC<Props> = ({ className }) => (
  <StarsInfo type="error" className={className}>
    <Translation {...TXTCLI_The_current_password_you_have__ELL} />
  </StarsInfo>
);

export default WrongPasswordMessage;
